export enum RecordType {
	CLIENT = 'client',
	CREATE_CLIENT = 'create-client',
	INSTITUTION = 'institution',
	SPONSOR = 'sponsor',
	SPONSOR_PERSONS = 'sponsor-persons',
	INSTITUTION_PERSONS = 'institution-persons',
	INSTITUTION_WORKPLACE = 'institution-workplace',
	INTEGRATION_OFFICE_SERVICE = 'integration-service-office',
	CREATE_INSTITUTION = 'create-institution',
	CREATE_INSTITUTION_PERSON = 'create-institution-person',
	CREATE_SPONSOR_PERSON = 'create-sponsor-person',
	CREATE_INSTITUTION_WORKPLACE = 'create-institution-workplace',
	CREATE_USER = 'create-user',
	SPECIALIST_REPRESENTATION = 'specialist-representation',
	CREATE_NETWORK_CONTACT = 'create-network-contact',
	NETWORK_CONTACT = 'network-contact',
	USER = 'user',
}

export interface RecordFile {
	id: string;
	type: RecordType;
	title: string;
	route: string;
	icon: string;
	isTemporary: boolean;
	createdAt: Date;
	lastAccessed: Date;
	isDirty?: boolean;
	entityId?: string;
	metadata?: Record<string, unknown>;
}

export interface RecordOptions {
	entityId?: string;
	title?: string;
	icon?: string;
	metadata?: Record<string, unknown>;
	forceNew?: boolean;
	route?: string;
}

export type RecordManagerContext = 'default' | 'representation';
